import React from 'react';

export default function PageIntro({ title, description, bullets }) {
  return (
    <div style={{
      border: '1px solid #e6e6e6',
      background: '#fbfbfb',
      padding: 12,
      borderRadius: 6,
      marginBottom: 12
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h2 style={{ margin: '0 0 6px 0' }}>{title}</h2>
          <div style={{ color: '#444' }}>{description}</div>
        </div>
      </div>
      {bullets && bullets.length ? (
        <ul style={{ marginTop: 10, color: '#333' }}>
          {bullets.map((b, i) => <li key={i}>{b}</li>)}
        </ul>
      ) : null}
    </div>
  );
}
